const es = {
  common: {
    dailyLimit: "Límite diario alcanzado. Vuelve mañana.",
    loading: "Cargando...",
    serverError: "Error del servidor",
  },
  intro: { playNow: "Jugar", knowMore: "Saber más" },
  login: {
    fillFields: "¡Por favor complete todos los campos!",
    invalid: "Número inválido",
    title: "Iniciar sesión para comenzar el juego",
    number: "Ingrese número de contacto",
    numberLabel: "Ingrese el número de móvil",
    numberPlaceholder: "Número de móvil",
    password: "Ingrese la contraseña",
    login: "Iniciar sesión",
    subscribeLink: "¿No eres usuario? Suscríbete",
    lowbalance:
      "No tiene saldo suficiente. Recargue su saldo e intente acceder de nuevo.",
    inprocess: "El cobro del servicio está en proceso. Espere un momento.",
    invalidNumber: "Ingrese un número de teléfono válido.",
    errorMsg: "¡Algo salió mal!",
    notSub: "No se encontró suscripción",
  },
  register: {
    fillFields: "¡Por favor complete todos los campos!",
    title: "Suscríbete para comenzar",
    name: "Ingrese el nombre",
    number: "Ingrese número de contacto",
    numberLabel: "Ingrese el número de móvil",
    numberPlaceholder: "Número de móvil",
    password: "Ingrese la contraseña",
    subscribe: "Suscribirse",
    loginLink: "¿Ya eres usuario? Iniciar sesión",
    dailyPass: "Pase diario",
    dailyDesc: "24 horas de juegos",
    weeklyPass: "Pase semanal",
    weeklyDesc: "7 días de acceso",
    monthlyPass: "Pase mensual",
    monthlyDesc: "30 días de juegos",
    privacy: "Complemento de privacidad",
    acceptPrivacy: "Acepte el complemento de privacidad",
    paymentNote: "Pago a través del saldo principal o M-Pesa",
    lowbalance:
      "No tiene saldo suficiente. Recargue su saldo e intente acceder de nuevo.",
    inprocess: "El cobro del servicio está en proceso. Espere un momento.",
    redirect: "Espere, será redirigido para confirmar su suscripción",
    subSuccess:
      "Recibirá un mensaje de confirmación de suscripción; confírmelo. Luego pulse el botón de abajo para acceder.",
    invalidNumber: "Ingrese un número de teléfono válido.",
    alreadySub:
      "Ya está suscrito. Para acceder al servicio, pulse el botón 'Haga clic aquí' abajo",
    errorMsg: "¡Algo salió mal!",
    clickHere: "Haga clic aquí",
    notSub: "No se encontró suscripción",
  },
  home: { title: "Niveles de juego" },
  account: {
    account_subtitle: "Jugador del juego de fichas ocultas",
    pointText: "Puntos totales",
    currentlevel: "Nivel actual",
    gameprogress: "Progreso del juego",
    levelprogress: "Progreso de nivel",
    btn: "Cancelar suscripción",
    unsubTitle: "Confirmar cancelación",
    unsubText:
      "¿Seguro que quieres cancelar tu suscripción actual? Puedes perder el acceso a las funciones premium y a los beneficios activos.",
    unsubCancel: "NO",
    unsubConfirm: "SÍ",
    errorMsg: "¡Algo salió mal!",
    nameUpdated: "¡Nombre actualizado!",
    editProfile: "Editar perfil",
    save: "Guardar",
    cancel: "Cancelar",
    wheelSpin: "Ruleta",
    locked: "Bloqueado",
    completeLevel10: "Completa el nivel 10",
    alreadySpin: "Ya giraste hoy",
    goHome: "Ir al inicio",
    userHistory: "Historial",
  },
  level: {
    level: "Nivel",
    subtitle: "¡Encuentra el objeto correcto!",
    tapPuzzle: "Toca para abrir el acertijo",
    puzzleTitle: "Acertijo",
    chooseObj: "Ahora elige el objeto correcto",
    gameOver: "Juego terminado",
    usedTries: "Has usado todos los intentos",
    restart: "Reiniciar",
    home: "Inicio",
    wrong: "¡Incorrecto! Intenta otra vez",
    correct: "Correcto",
    loading: "Cargando...",
    silverUnlocked: "¡Chit de plata desbloqueado!",
    goldenUnlocked: "¡Chit de oro desbloqueado!",
    diamondUnlocked: "¡Chit de diamante desbloqueado!",
    exploreNow: "Explorar ahora",
    claimReward: "Reclamar recompensa",
    timeLeft: "Tiempo restante",
  },
  history: {
    levelHistory: "Historial de niveles",
    spinHistory: "Historial de giros",
    goldenTitle: "Recompensa de chit oro",
    diamondTitle: "Recompensa de chit diamante",
    noHistory: "No hay historial",
    level: "Nivel",
    points: "Puntos",
    date: "Fecha",
    riddle: "Acertijo",
    answer: "Respuesta",
    spin: "Giro",
    goldenReward: "Recompensa de chit oro",
    reward: "Recompensa",
    goldenRewardLabel: "Recompensa de oro",
    type: "Tipo",
    diamond: "Diamante",
    noDiamond: "No hay recompensa de diamante",
  },
  silver: {
    wonPrize: "Premio ganado",
    clickOpen: "Toca para abrir",
    opening: "Abriendo...",
    spinning: "Girando...",
    spinWheel: "Girar la rueda",
    youWon: "Ganaste",
    nextLevel: "Siguiente nivel",
  },
  golden: { congrats: "¡Felicidades!", claimPrize: "Reclamar premio" },
  diamond: {
    title: "Archivo de diamante",
    claimAll: "Reclamar todas las recompensas",
    hint: "¡Toca el sobre de diamante para abrir!",
    data: "Datos",
    points: "Puntos",
  },
  finish: {
    gameOver: "FIN DEL JUEGO",
    clickEnvelopes: "Toca los sobres para revelar recompensas",
    screenshotTip: "¡Haz una captura y comparte tu victoria!",
    allCollected: "¡TODO RECOGIDO!",
    finalText:
      "Has recogido todos los tesoros. Revisa tu cuenta para el saldo total.",
    goAccount: "IR A LA CUENTA",
    toolLoading: "La herramienta aún carga...",
    victory: "¡Victoria!",
    shareText: "¡Gané en Hidden Chit Game!",
  },
  levelMap: {
    subHeader: "¡Completa los 50 niveles y desbloquea recompensas!",
    silver: "Chit de plata",
    golden: "Chit de oro",
    diamond: "Chit de diamante",
    trophy: "Trofeo",
  },
};

export default es;
